import styled from 'styled-components';
import { AdornmentRightMixin } from '../../mixins/components/AdornmentMixin';
import { StyledAdornment } from '../Adornment/Adornment.styles';
var AdornmentRight = /*#__PURE__*/styled(StyledAdornment).withConfig({
  displayName: "AdornmentRight",
  componentId: "c11n-8-107-0__sc-46k37c-0"
})(["", ""], AdornmentRightMixin);
AdornmentRight.displayName = 'AdornmentRight';

/** @component */
export { AdornmentRight };